import * as React from 'react';
import {RecommendationBoxProps} from '@volkswagen-onehub/whitelabel-e-mobility-commons';
import styled from 'styled-components';
import {BrandThemeProvider} from '../theme';

export function RecommendationBox(props: RecommendationBoxProps): JSX.Element {
  if (props.recommended) {
    return RecommendationBoxInverted(props.children);
  } else {
    return RecommendationBoxWrapper(props.children);
  }
}

export function RecommendationBoxInverted(
  children: React.ReactNode
): JSX.Element {
  return (
    <BrandThemeProvider theme="inverted">
      {RecommendationBoxWrapper(children)}
    </BrandThemeProvider>
  );
}

export function RecommendationBoxWrapper(
  children: React.ReactNode
): JSX.Element {
  return <RecommendationBoxHolder>{children}</RecommendationBoxHolder>;
}

const RecommendationBoxHolder = styled.div`
  border-radius: 0 0 ${(props) => props.theme.brand.spacing.tile.borderRadius}
    ${(props) => props.theme.brand.spacing.tile.borderRadius};
  background: ${(props) => props.theme.colors.background.tertiary};
`;
